import React, { useState } from 'react';
import { IonButton, IonTextarea, IonSelect, IonSelectOption, IonLabel, IonItem, IonText } from '@ionic/react';
import './FeedbackComponent.css';
import { _dict, _feedbackMinLen, firebaseConfig } from './constants';
import { useGlobalStore } from './stateManagement/globalZustand';
import { addDoc, collection, getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const FeedbackComponent: React.FC = () => {
    const { lang } = useGlobalStore();
    const [feedbackType, setFeedbackType] = useState('');
    const [feedback, setFeedback] = useState('');
    const [feedbackError, setFeedbackError] = useState('');
    const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);

    const validateFeedback = () => {
        if (!feedbackType) {
            setFeedbackError(_dict["feedbackTypeError"][lang]);
            return false;
        }
        if (!feedback || feedback.length < _feedbackMinLen) {
            setFeedbackError(_dict["feedbackLengthError"][lang]);
            return false;
        }
        setFeedbackError('');
        return true;
    };

    const submitFeedback = async () => {
        if (!validateFeedback()) {
            return;
        }

        try {
            const docRef = await addDoc(collection(db, "feedback"), {
                feedbackType: feedbackType,
                feedback: feedback,
                timestamp: new Date() // Optional, to track when the feedback was submitted
            });
    
            console.log("Feedback submitted with ID: ", docRef.id);
            // Reset form or show a success message
            // resetForm(); // Example function call to reset the form
            // showSuccessMessage(); // Example function call to show success message
        } catch (error) {
            console.error("Error adding document: ", error);
            // Handle error (e.g., show error message)
        }
    };

    return (
        <div className="feedback-container">
            <h2 className="feedback-heading">
                {_dict["notFindingWhatYouAreLookingFor"][lang]}
                {" "}
                {_dict["tellUsMore"][lang]}
            </h2>
            <IonItem>
                <IonLabel>{_dict["selectCategory"][lang]}</IonLabel>
                <IonSelect 
                    value={feedbackType} 
                    placeholder={_dict["selectOneOption"][lang]} 
                    onIonChange={e => setFeedbackType(e.detail.value)}>
                    <IonSelectOption value="newFeature">{_dict["requestNewFeature"][lang]}</IonSelectOption>
                    <IonSelectOption value="improveFeature">{_dict["improveExistingFeature"][lang]}</IonSelectOption>
                    <IonSelectOption value="question">{_dict["askForContent"][lang]}</IonSelectOption>
                    <IonSelectOption value="reportBug">{_dict["reportBug"][lang]}</IonSelectOption>
                    <IonSelectOption value="other">{_dict["other"][lang]}</IonSelectOption>
                </IonSelect>
            </IonItem>

            <IonTextarea
                value={feedback}
                placeholder={_dict["describeHereYourRequest"][lang]}
                onIonChange={e => setFeedback(e.detail.value!)}
            />

            {feedbackError && <IonText color="danger">{feedbackError}</IonText>}

            <IonButton
                color="dark"
                expand="block"
                onClick={submitFeedback}
                disabled={!feedbackType || !feedback || feedback.length < _feedbackMinLen}
            >
                {_dict["send"][lang]}
            </IonButton>

            {!feedbackType && !feedback && feedback.length < _feedbackMinLen && (
                <IonText color="dark">{_dict["feedbackTypeError"][lang]}
                {". "}
                {_dict["feedbackLengthError"][lang]}
                </IonText>
            )}
        </div>
    );
};

export default FeedbackComponent;
